<template>
    <div class="home">
        <v-container grid-list-md grid-list-xs>
            <v-layout row wrap>
                <v-flex class="welcome-message" xs12>
                    <h2>Welcome to MODPlug Central!</h2>
                    <p>MODPlug Central is the place to download free music software for creating and playing back
                        original compositions on your computer, as well as discover some great
                        <a href="http://forum.openmpt.org/index.php?board=6.0">free music</a> uploaded by other artists!
                    The MODPlug Software is completely free and allows you to create and play back some great music
                    on your computer.</p>
                </v-flex>
                <v-flex class="software-downloads" xs12>
                    <h2>Download Free MODPlug Music Software</h2>
                    <v-layout row wrap>
                        <v-flex md4 xs12>
                            <div class="software-box">
                                <div class="software-image">
                                    <a href="http://openmpt.org/features">
                                        <img src="@/assets/img/modplug_tracker_title.png" />
                                    </a>
                                </div>
                                <div class="software-info">
                                    <h3>MODPlug Tracker</h3>
                                    <p>The MODPlug Tracker is free, powerful software that enables you to easily
                                        create music on your Windows-based PC using instruments freely available on the
                                        internet.</p>
                                </div>
                                <div class="software-links">
                                    <a href="http://openmpt.org/download">
                                        <v-btn>Download</v-btn>
                                    </a>
                                    <a href="http://openmpt.org/features">
                                        <v-btn>More Information</v-btn>
                                    </a>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex md4 xs12>
                            <div class="software-box">
                                <div class="software-image">
                                    <a href="http://openmpt.org/legacy_software">
                                        <img src="@/assets/img/modplug_player_title.png" />
                                    </a>
                                </div>
                                <div class="software-info">
                                    <h3>MODPlug Player</h3>
                                    <p>The MODPlug Player is a compact, versatile player for your Windows-based PC that
                                        accurately plays files created using the MODPlug Tracker and other Tracking
                                        programs.</p>
                                </div>
                                <div class="software-links">
                                    <a href="http://openmpt.org/legacy_software">
                                        <v-btn>Download</v-btn>
                                    </a>
                                    <a href="http://openmpt.org/legacy_software">
                                        <v-btn>More Information</v-btn>
                                    </a>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex md4 xs12>
                            <div class="software-box">
                                <div class="software-image">
                                    <router-link to="/tracker">
                                        <img src="@/assets/img/modview.gif" />
                                    </router-link>
                                </div>
                                <div class="software-info">
                                    <h3>MODPlug Plugin</h3>
                                    <p>
                                        Although development has ceased on the plugin, it is still available for
                                        download by clicking the link below:
                                    </p>
                                </div>
                                <div class="software-links">
                                    <a href="http://openmpt.org/legacy_software">
                                        <v-btn>Download</v-btn>
                                    </a>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 class="text-xs-center">
                    <Adsense
                        data-ad-client="ca-pub-1585481048202082"
                        data-ad-slot="2734382232"
                        data-ad-format="auto"
                        data-full-width-responsive="true"
                    ></Adsense>
                </v-flex>
                <v-flex xs12>
                    <h2>Free Music Community</h2>
                    <p>Join the Free Music Community in the <a href="http://forum.openmpt.org/">MODPlug Central Forums</a> to discuss tips tricks and
                        techniques, as well as discuss the latest versions of the MODPlug software.</p>
                </v-flex>
                <v-flex xs12>
                    <h2>Random Song Title Generator</h2>
                    <p>
                        Stuck on a title for your song or a name for your band? The MODPlug Central
                        <router-link to="/random-title-generator">Random Title Generator</router-link> is here to help!
                    </p>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'home',
        title: 'MODPlug Central - Free Music Software'
    }
</script>
<script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
<!-- MPC Responsive Ad Unit -->
<ins class="adsbygoogle"
     style="display:block"
     data-ad-client="ca-pub-1585481048202082"
     data-ad-slot="2734382232"
     data-ad-format="auto"
     data-full-width-responsive="true"></ins>
<script>
    (adsbygoogle = window.adsbygoogle || []).push({});
</script>